// Register each file as a corresponding Vuex module. Module nesting
// will mirror [sub-]directory hierarchy and modules are namespaced
// as the camelCase equivalent of their filename.

import camelCase from 'lodash.camelcase'

// Vite's import.meta.glob replaces webpack's require.context.
// https://vitejs.dev/guide/features.html#glob-import
// Exclude unit tests in the pattern itself. With `eager`, every matched file
// is imported immediately (before the loop below can filter), so a `*.unit.js`
// match would execute test code at app startup.
const requireModule = import.meta.glob(['./**/*.js', '!./**/*.unit.js'], {
  eager: true,
})
const root = { modules: {} }

Object.keys(requireModule).forEach((fileName) => {
  // Skip this file and any unit tests, as they're not modules.
  if (fileName === './index.js' || /\.unit\.js$/.test(fileName)) return

  // Get the module path as an array
  const modulePath = fileName
    // Remove the "./" from the beginning
    .replace(/^\.\//, '')
    // Remove the file extension from the end
    .replace(/\.\w+$/, '')
    // Split nested modules into an array path
    .split(/\//)
    // camelCase all module namespaces and names
    .map(camelCase)

  // Get the modules object for the current path
  const { modules } = getNamespace(root, modulePath)

  // Add the module to our modules object. The modules use named exports
  // (state/getters/mutations/actions), so spread the whole module namespace
  // (and its default export, if any).
  const mod = requireModule[fileName]
  modules[modulePath.pop()] = {
    // Modules are namespaced by default
    namespaced: true,
    ...mod,
    ...(mod.default || {}),
  }

  // Recursively get the namespace of the module, even if nested
  function getNamespace(subtree, path) {
    if (path.length === 1) return subtree

    const namespace = path.shift()
    subtree.modules[namespace] = { modules: {}, ...subtree.modules[namespace] }
    return getNamespace(subtree.modules[namespace], path)
  }
})

export default root.modules
